import React, { useEffect, useState } from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import { Title } from "@src/components/atoms/title/title";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import plusDarkIcon from "@src/assets/svg/plus-dark-icon.svg";
import { v4 as uuidv4 } from "uuid";
import styles from "./alarm-profiles-drawer-modal.module.scss";
import { AlarmProfilesCardsWrapper } from "@src/components/molecules/alarm-profiles-cards-wrapper/alarm-profiles-cards-wrapper";
import { DrawerIconContainer } from "@src/components/atoms/drawer-icon-container/drawer-icon-container";
import alarmProfileWhiteIcon from "@src/assets/svg/alarm-profile-white.svg";
import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { AlarmProfile } from "@src/cloud-connect/alarms/entities/alarm-profile";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { EMail } from "@src/cloud-connect/alarms/entities/email";
import { Notifications } from "@src/cloud-connect/alarms/entities/notifications";
import {
  emptyAlarmNodeData,
  updateAlarmNodeSelectionData,
  updateAlarmNodeSelectionState,
} from "@src/reducers/your-reducer";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "@src/components/molecules/render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "alarm-profiles-drawer-modal";

export const AlarmProfilesDrawerModal = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const clientId = useSelector(
    (state: RootState) =>
      state.yourSlice.connectionView.source.connected_via_client,
  );

  const sourceId = useSelector(
    (state: RootState) => state.yourSlice.connectionView.source.source_id,
  );

  const [localAlarmProfiles, setLocalAlarmProfiles] = useState([]);

  const texts = {
    title: i18n("modules.alarmProfilesDrawerModal.title"),
    mainButton: i18n("modules.alarmProfilesDrawerModal.mainButton"),
    placeHolderName: i18n("modules.alarmProfilesDrawerModal.placeHolderName"),
    placeHolderDescription: i18n(
      "modules.alarmProfilesDrawerModal.placeHolderDescription",
    ),
  };

  const alarmProfilesInstance = getAlarmProfiles();

  const addAlarmProfile = () => {
    const newEMail = new EMail(false, "", "", []);
    const newNotifications = new Notifications(newEMail);

    const newAlarmProfile = new AlarmProfile(
      sourceId,
      clientId,
      false,
      uuidv4(),
      texts.placeHolderName,
      texts.placeHolderDescription,
      newNotifications,
      [],
      true,
    );

    const updatedProfiles = [
      ...alarmProfilesInstance.getAlarmProfiles(),
      newAlarmProfile,
    ];

    alarmProfilesInstance.setAlarmProfiles(updatedProfiles);
  };

  const activateProfile = (id: string) => {
    const updatedProfiles = alarmProfilesInstance
      .getAlarmProfiles()
      .map((profile) => {
        profile.setActive(profile.getId() === id);
        return profile;
      });

    dispatch(updateAlarmNodeSelectionState("none"));
    dispatch(updateAlarmNodeSelectionData(emptyAlarmNodeData));
    alarmProfilesInstance.setAlarmProfiles(updatedProfiles);
  };

  useEffect(() => {
    const updateAlarmProfilesCards = () => {
      const alarmProfiles = alarmProfilesInstance.getAlarmProfiles();
      setLocalAlarmProfiles(alarmProfiles);
    };

    updateAlarmProfilesCards();

    alarmProfilesInstance.addObserver(updateAlarmProfilesCards);

    return () => {
      alarmProfilesInstance.removeObserver(updateAlarmProfilesCards);
    };
  }, [alarmProfilesInstance]);

  return (
    <DrawerModal id={"alarmProfilesDrawerModal"}>
      <div className={styles[cssClassName]}>
        <FlexColumnContainer verticalGap={32}>
          <Title text={texts.title} />
          <DrawerIconContainer icon={alarmProfileWhiteIcon} />
          <RenderIfUserHasPermission permission="manage-condition-monitoring">
            <ButtonWithIcon
              variant={"full-width"}
              fun={addAlarmProfile}
              icon={plusDarkIcon}
              text={texts.mainButton}
            />
          </RenderIfUserHasPermission>
          <AlarmProfilesCardsWrapper
            alarmProfiles={localAlarmProfiles}
            activateProfile={activateProfile}
          />
        </FlexColumnContainer>
      </div>
    </DrawerModal>
  );
};
